import React from "react";

//** NDBX */
import { Stack, Section, LabelTooltip } from "@arp/react-ndbx";
//** MUI */
import { Typography } from "@mui/material";

//* Hooks
import { useGetQuote } from "../../../hooks/dataHooks/useGetQuoteData.js";

//** Config */
import { formatPercentage } from "../../../utilities/numericFormat.js";
import { quoteSummaryDynamicTooltip } from "../../../config/tooltips/pageTooltips";

//----------------------------------------------------------------

export const Discount = ({ ...props }) => {
  const { isLoading, error, data } = useGetQuote();
  const { quoteInformation } = { ...data };

  const showTooltip = true;
  const marginBottom = 0;
  const alignTooltip = "flex-start";

  const tooltip = quoteSummaryDynamicTooltip(
    quoteInformation?.discountPercentage
  );

  return (
    <Section mt={2}>
      <Stack
        direction="row"
        mb={marginBottom}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: { alignTooltip },
        }}
      >
        <Typography
          variant="p2-bold"
          display={{ display: "inline-flex", justifyContent: "center" }}
        >
          Your {formatPercentage(quoteInformation?.discountPercentage, 0)}{" "}
          discount has been applied*{" "}
          {showTooltip ? (
            <LabelTooltip
              mt={0}
              controlIdentifier={"aus-resident"}
              tooltipTitle={tooltip[0].DISCOUNT_TOOLTIP}
            />
          ) : null}
        </Typography>
      </Stack>
    </Section>
  );
};
